import { createAnchor, getPositionFromIndex } from "../components/AutoSuggestion";
import { findTabularEnvs, parseColumnSpec, findCommandorNot, capitalizeInsideBraces, isCommented, getallData, getInsideTextofBraces, createGranularAnchors, isLineCommented, LineCommented, numberToWords } from "../components/ReusableFunctions";
import { getOverlappingAnchors, isAlreadyAnchored, isRejectedByLivePosition } from "../components/AutoSuggestion";

export const edp = {
    // RemoveHiddenText: {
    //     name: "Remove Hidden Text start with %",
    //     description: "Remove commented/hidden text from LaTeX",
    //     markerClass: "ace-Common-highlight",

    //     execute(texFile, session, Range, anchorlist,
    //         fileName, Allfiles,
    //         existingSuggestions = [],
    //         rejectedSuggestions = []) {
    //         const staleIds = new Set();
    //         const lines = texFile.split('\n');
    //         let index = 0;

    //         lines.forEach((line, lineNum) => {
    //             const lineStart = index;
    //             index += line.length + 1; // +1 for \n

    //             // Find % that is not escaped with \
    //             const commentIdx = line.search(/(?<!\\)%/);
    //             if (commentIdx === -1) return;

    //             const beforeComment = line.slice(0, commentIdx);
    //             const isFullLine = beforeComment.trim() === '';

    //             let fullMatch, matchIndex, extraStyleInfo;

    //             if (isFullLine) {
    //                 // ── Full line — anchor just the line text (no \n) ──
    //                 // removeType:'fullLine' tells applyAcceptToEditor to delete the whole line
    //                 fullMatch = line;
    //                 matchIndex = lineStart;
    //                 extraStyleInfo = { removeType: 'fullLine' };
    //             } else {
    //                 // ── Partial comment — anchor only the % and everything after ──
    //                 // Trim trailing spaces before the % too
    //                 const trimmedBefore = beforeComment.trimEnd();
    //                 const extraSpaces = beforeComment.length - trimmedBefore.length;
    //                 fullMatch = line.slice(commentIdx - extraSpaces); // spaces + %comment
    //                 matchIndex = lineStart + commentIdx - extraSpaces;
    //                 extraStyleInfo = { removeType: 'partial' };
    //             }

    //             const position = getPositionFromIndex(texFile, matchIndex, fullMatch.length);

    //             if (isRejectedByLivePosition(position, this.name, fullMatch)) return;

    //             const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
    //             if (overlapping.length > 0) {
    //                 overlapping.forEach(old => staleIds.add(old.id));
    //             } else {
    //                 if (isAlreadyAnchored(position, this.name, existingSuggestions)) return;
    //             }

    //             createAnchor(session, Range, position,
    //                 fullMatch, '',
    //                 this.markerClass, this.name, this.description,
    //                 anchorlist, extraStyleInfo);
    //         });

    //         return staleIds;
    //     }
    // },
    RemoveHiddenText: {
        name: "Remove Hidden Text start with %",
        description: "Remove commented/hidden text from LaTeX",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const lines = texFile.split('\n');
            let index = 0;

            lines.forEach((line, lineNum) => {
                const lineStart = index;
                index += line.length + 1; // +1 for \n

                // Find % that is not escaped with \
                const commentIdx = line.search(/(?<!\\)%/);
                if (commentIdx === -1) return;

                const beforeComment = line.slice(0, commentIdx);
                const isFullLine = beforeComment.trim() === '';

                let fullMatch, matchIndex, extraStyleInfo;

                if (isFullLine) {
                    // ── Full line — anchor just the line text (no \n) ──
                    // removeType:'fullLine' tells applyAcceptToEditor to delete the whole line
                    fullMatch = line;
                    matchIndex = lineStart;
                    extraStyleInfo = { removeType: 'fullLine' };
                } else {
                    // ── Partial comment — anchor only the % and everything after ──
                    // Trim trailing spaces before the % too
                    const trimmedBefore = beforeComment.trimEnd();
                    const extraSpaces = beforeComment.length - trimmedBefore.length;
                    fullMatch = line.slice(commentIdx - extraSpaces); // spaces + %comment
                    matchIndex = lineStart + commentIdx - extraSpaces;
                    extraStyleInfo = { removeType: 'partial' };
                }

                const position = getPositionFromIndex(texFile, matchIndex, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) return;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) return;
                }

                createAnchor(session, Range, position,
                    fullMatch, '',
                    this.markerClass, this.name, this.description,
                    anchorlist, extraStyleInfo);
            });

            return staleIds;
        }
    },
    separateAuthor: {
        name: "Separate Author",
        description: "Author separated with comma and insert and before last author.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const authorPattern = /\\author\s*(?:\[[^\]]*\])?\s*\{/gi;
            let match;

            while ((match = authorPattern.exec(texFile)) !== null) {
                let depth = 1, i = match.index + match[0].length, content = '';
                while (i < texFile.length && depth > 0) {
                    if (texFile[i] === '{') depth++;
                    else if (texFile[i] === '}') { depth--; if (depth === 0) break; }
                    content += texFile[i]; i++;
                }

                const fullMatch = texFile.slice(match.index, i + 1);
                const optionalArg = match[0].match(/\[[^\]]*\]/)?.[0] || '';

                if (!content.includes(',')) continue;

                const authors = content.split(',').map(a => a.trim()).filter(Boolean);
                if (authors.length < 2) continue;

                const newContent = authors.slice(0, -1).join(', ') + ' and ' + authors[authors.length - 1];
                const suggestion = `\\author${optionalArg}{${newContent}}`;

                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);

                if (overlapping.length > 0) {
                    overlapping.forEach(old => {
                        if (old.originalText === fullMatch) {
                            if (!session.getMarkers()[old.markerId]) {
                                old.markerId = session.addMarker(
                                    new Range(position.startRow, position.startCol, position.endRow, position.endCol),
                                    this.markerClass,
                                    "text"
                                );
                            }
                        } else {
                            staleIds.add(old.id);
                        }
                    });
                    if (overlapping.every(old => old.originalText === fullMatch)) continue;
                } else {
                    // ── Exact match check — pass originalText to verify content ──
                    if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position,
                        fullMatch, suggestion,
                        this.markerClass, this.name, this.description, anchorlist);
                }
            }

            return staleIds;
        }
    },
    nameCapitalize: {
        name: "Capitalize Names",
        description: "Capitalize each word of the author",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const authorPattern = /\\author\s*(?:\[[^\]]*\])?\s*\{/gi;
            let match;

            while ((match = authorPattern.exec(texFile)) !== null) {
                let depth = 1, i = match.index + match[0].length, content = '';
                while (i < texFile.length && depth > 0) {
                    if (texFile[i] === '{') depth++;
                    else if (texFile[i] === '}') { depth--; if (depth === 0) break; }
                    content += texFile[i]; i++;
                }

                const fullMatch = texFile.slice(match.index, i + 1);
                const optionalArg = match[0].match(/\[[^\]]*\]/)?.[0] || '';

                // ── Capitalize each word but preserve LaTeX commands ──
                const newContent = content
                    .split(' ')
                    .map(w => {
                        // Don't capitalize LaTeX commands (\something)
                        if (w.startsWith('\\')) return w;
                        if (w.length === 0) return w;
                        return w.charAt(0).toUpperCase() + w.slice(1);
                    })
                    .join(' ');

                const suggestion = `\\author${optionalArg}{${newContent}}`;
                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position,
                        fullMatch, suggestion,
                        this.markerClass, this.name, this.description, anchorlist);
                }
            }

            return staleIds;
        }
    },

    removeHonorifics: {
        name: "Remove Honorifics",
        description: "Remove honorifics from the author name.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();

            const honorifics = new Set([
                "mr", "mister", "mrs", "miss", "ms", "mx",
                "dr", "doctor", "prof", "professor", "phd", "eng", "esq", "esquire",
                "sir", "madam", "dame", "lord", "lady", "baron", "baroness",
                "count", "countess", "duke", "duchess", "earl", "viscount",
                "princess", "prince", "king", "queen",
                "capt", "captain", "col", "colonel", "maj", "major",
                "lt", "lieutenant", "cmdr", "commander", "sgt", "sergeant",
                "cpl", "corporal", "gen", "general", "adm", "admiral",
                "rev", "reverend", "fr", "father", "sis", "sister",
                "pastor", "imam", "imām", "rabbi", "sheikh", "shaykh",
                "mufti", "bishop", "archbishop", "pope", "cardinal",
                "brother", "elder", "pandit", "guru", "swami",
                "sri", "shri", "smt", "ji", "babu", "rao", "devi",
                "kumari", "chan", "san", "kun", "sama", "sensei",
                "hon", "honorable", "rt", "rt.", "sen", "senator",
                "rep", "representative", "pres", "president",
                "gov", "governor", "amb", "ambassador",
                "tunku", "tuan", "puan", "dato", "datuk", "tan",
                "tengku", "nguyen", "madame", "monsieur", "herr",
                "frau", "signor", "signora", "don", "doña"
            ]);

            const authorPattern = /\\author\s*(?:\[[^\]]*\])?\s*\{/gi;
            let match;

            while ((match = authorPattern.exec(texFile)) !== null) {
                let depth = 1, i = match.index + match[0].length, content = '';
                while (i < texFile.length && depth > 0) {
                    if (texFile[i] === '{') depth++;
                    else if (texFile[i] === '}') { depth--; if (depth === 0) break; }
                    content += texFile[i]; i++;
                }

                const fullMatch = texFile.slice(match.index, i + 1);
                const optionalArg = match[0].match(/\[[^\]]*\]/)?.[0] || '';

                // ── Remove honorifics — preserve LaTeX commands ──
                const newContent = content
                    .split(/\s+/)
                    .filter(word => {
                        if (word.startsWith('\\')) return true; // keep LaTeX commands
                        const normalized = word.toLowerCase().replace(/\.$/, '');
                        return !honorifics.has(normalized);
                    })
                    .join(' ')
                    .trim();

                const suggestion = `\\author${optionalArg}{${newContent}}`;
                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position,
                        fullMatch, suggestion,
                        this.markerClass, this.name, this.description, anchorlist);
                }
            }

            return staleIds;
        }
    },
    abstractfloatingobject: {
        name: "Remove floating from abstract",
        description: "Deletes floating objects like figures, tables, textboxes etc from abstract block.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {

            const staleIds = new Set();
            // Regex to find the abstract block and capture its content
            const abstractPattern = /\\begin\{abstract\}([\s\S]*?)\\end\{abstract\}/gi;
            let match;

            while ((match = abstractPattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const abstractContent = match[1];

                // Patterns for objects to be removed
                const floatingPatterns = [
                    /\\begin\{table\}[\s\S]*?\\end\{table\}/gi,
                    /\\begin\{figure\}[\s\S]*?\\end\{figure\}/gi,
                    /\\begin\{textboxes\}[\s\S]*?\\end\{textboxes\}/gi
                ];

                let suggestionContent = abstractContent;
                let hasFloating = false;

                // Check and replace each floating object type within the captured content
                for (const pattern of floatingPatterns) {
                    if (pattern.test(suggestionContent)) {
                        suggestionContent = suggestionContent.replace(pattern, "");
                        hasFloating = true;
                    }
                }

                // If no floating objects were found, skip creating an anchor
                if (!hasFloating) continue;

                const suggestion = `\\begin{abstract}${suggestionContent}\\end{abstract}`;

                // Calculate position for the entire abstract block
                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                // Check if this specific suggestion/position was rejected by the user
                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                // Handle Overlapping and Stale Anchors
                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => {
                        if (old.originalText !== fullMatch) {
                            staleIds.add(old.id);
                        }
                    });
                    const allSame = overlapping.every(old => old.originalText === fullMatch);
                    if (allSame) continue;
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) continue;
                }

                // Final check to ensure we aren't inside a commented line or invalid context
                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(
                        session,
                        Range,
                        position,
                        fullMatch,
                        suggestion,
                        this.markerClass,
                        this.name,
                        this.description,
                        anchorlist
                    );
                }
            }

            return staleIds;
        }
    },
    abstractFormatting: {
        name: "Abstract Formatting",
        description: "Remove any new line or heading present in the abstract.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();

            const abstractPattern = /\\begin\{abstract\}([\s\S]*?)\\end\{abstract\}/g;
            let match;

            while ((match = abstractPattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                let content = match[1];

                // ── Remove headings ──
                content = content.replace(
                    /\\(?:section|subsection|subsubsection)\*?\{.*?\}/g, ''
                );

                // ── Collapse newlines and extra spaces ──
                content = content.replace(/\n+/g, ' ').replace(/\s{2,}/g, ' ').trim();

                const suggestion = `\\begin{abstract}\n${content}\n\\end{abstract}`;

                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                createAnchor(session, Range, position,
                    fullMatch, suggestion,
                    this.markerClass, this.name, this.description, anchorlist);
            }

            return staleIds;
        }
    },
    keywordFormatting: {
        name: "Keyword Formatting",
        description: "First keyword capitalized, rest lowercase except proper nouns.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();

            const keywordsPattern = /\\keywords\s*\{([^}]*)\}/gm;
            let match;

            while ((match = keywordsPattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const content = match[1];

                const keywords = content.split(',').map(k => k.trim());

                const processed = keywords.map((word, index) => {
                    if (index === 0) {
                        // ── First keyword: capitalize first letter only ──
                        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                    } else {
                        // ── Rest: all lowercase except first letter of each word
                        // that looks like a proper noun (starts with uppercase) ──
                        return word
                            .split(' ')
                            .map(w => {
                                // Keep LaTeX commands as-is
                                if (w.startsWith('\\')) return w;
                                // If original word was capitalized treat as proper noun
                                if (w.charAt(0) === w.charAt(0).toUpperCase() &&
                                    w.charAt(0) !== w.charAt(0).toLowerCase()) {
                                    return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
                                }
                                return w.toLowerCase();
                            })
                            .join(' ')
                            .trim();
                    }
                });

                const suggestion = `\\keywords{${processed.join(', ')}}`;
                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position,
                        fullMatch, suggestion,
                        this.markerClass, this.name, this.description, anchorlist);
                }
            }

            return staleIds;
        }
    },
    historydates: {
        name: "History Dates Style",
        description: "Date of receipt and revision separated by a dot; dot at the end of the line.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {

            const staleIds = new Set();
            // Regex to find \title{...} and capture content inside braces
            const titlePattern = /\\title\s*\{/gi;
            let match;

            while ((match = titlePattern.exec(texFile)) !== null) {
                // Use helper to get full content within balanced braces
                let depth = 1, i = match.index + match[0].length, content = '';
                while (i < texFile.length && depth > 0) {
                    if (texFile[i] === '{') depth++;
                    else if (texFile[i] === '}') { depth--; if (depth === 0) break; }
                    content += texFile[i]; i++;
                }

                const fullMatch = texFile.slice(match.index, i + 1);

                // Look for date-related keywords to see if history dates exist
                const dateKeywords = /(Received|Revised|Accepted|Date of receipt|Date of revision)/i;
                if (!dateKeywords.test(content)) continue;

                // Logic: 
                // 1. Replace various separators (comma, semicolon, or just space) between date blocks with a dot.
                // 2. Ensure the whole string ends with a dot.

                let newContent = content
                    .replace(/(Received[:\s]+[^;,\n]+)\s*[;,]\s*(Revised[:\s]+)/gi, '$1. $2') // Replace separator with dot
                    .trim();

                // Ensure it ends with a dot if it doesn't already
                if (newContent.length > 0 && !newContent.endsWith('.')) {
                    newContent += '.';
                }

                const suggestion = `\\title{${newContent}}`;

                // If no changes were actually made, skip
                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => {
                        if (old.originalText !== fullMatch) {
                            staleIds.add(old.id);
                        }
                    });
                    if (overlapping.every(old => old.originalText === fullMatch)) continue;
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position, fullMatch, suggestion, this.markerClass, this.name, this.description, anchorlist);
                }
            }

            return staleIds;
        }
    },

    sectionHeading: {
        name: "Section Heading Casing",
        description: "Capitalize only the first letter of the heading and proper nouns.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {

            const staleIds = new Set();

            // Match \section, \subsection, \subsubsection with optional *
            const sectionPattern = /\\(?:sub)*section\*?\s*\{/gi;
            let match;

            while ((match = sectionPattern.exec(texFile)) !== null) {
                // ── 1. Extract content using brace depth (Manual Parsing) ──
                let depth = 1, i = match.index + match[0].length, content = '';
                while (i < texFile.length && depth > 0) {
                    if (texFile[i] === '{') depth++;
                    else if (texFile[i] === '}') {
                        depth--;
                        if (depth === 0) break;
                    }
                    content += texFile[i];
                    i++;
                }

                const fullMatch = texFile.slice(match.index, i + 1);
                const commandPart = match[0]; // e.g., "\section{" or "\subsection*{"

                // ── 2. Apply Casing Logic ──
                const words = content.split(' ');
                const newContent = words.map((word, index) => {
                    if (word.length === 0) return "";

                    // Keep LaTeX commands untouched (e.g., \cite, \ref)
                    if (word.startsWith('\\')) return word;

                    // Rule: Always capitalize the first word of the heading
                    if (index === 0) {
                        return word.charAt(0).toUpperCase() + word.slice(1);
                    }

                    // Rule: Proper Noun Detection
                    // If the word is ALREADY capitalized in the source (and isn't just one char),
                    // we assume it is a proper noun and keep it capitalized.
                    const isOriginallyCapitalized = word.charAt(0) === word.charAt(0).toUpperCase() &&
                        word.charAt(0) !== word.charAt(0).toLowerCase();

                    if (isOriginallyCapitalized && word.length > 1) {
                        return word;
                    }

                    // Otherwise, lowercase the word
                    return word.toLowerCase();
                }).join(' ');

                const suggestion = `${commandPart}${newContent}}`;

                // ── 3. Validation and Anchor Creation ──
                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => {
                        if (old.originalText !== fullMatch) {
                            staleIds.add(old.id);
                        }
                    });
                    if (overlapping.every(old => old.originalText === fullMatch)) continue;
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(
                        session,
                        Range,
                        position,
                        fullMatch,
                        suggestion,
                        this.markerClass,
                        this.name,
                        this.description,
                        anchorlist
                    );
                }
            }

            return staleIds;
        }
    },

    quotation: {
        name: "Replace Quotation",
        description: "Replace paired single quotes with double quotes and strip inner LaTeX formatting.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {

            const staleIds = new Set();

            /**
             * The pattern looks for an opening single quote that is:
             * 1. At the start of a line OR preceded by a space/bracket (avoiding letters).
             * 2. Followed by content and a closing quote.
             * 3. The closing quote must be followed by a space, punctuation, or end of line.
             */
            const quotePattern = /(?:^|[\s\(\[\{])'(.*?)'(?=$|[\s\)\!\?\,\.\}\]])/gm;
            let match;

            while ((match = quotePattern.exec(texFile)) !== null) {
                let fullMatch = match[0];
                let content = match[1];

                // Detect if the regex grabbed a leading space/bracket
                const leadingCharMatch = fullMatch.match(/^[^\']/);
                const leadingChar = leadingCharMatch ? leadingCharMatch[0] : "";

                let targetText = fullMatch;
                let targetIndex = match.index;

                // Adjust index so the highlight starts exactly at the quote '
                if (leadingChar) {
                    targetText = fullMatch.slice(1);
                    targetIndex = match.index + 1;
                }

                // ── 1. Clean the content (Remove \textit{...}, \textbf{...}, etc.) ──
                // This converts '\textit{hello world}' -> 'hello world'
                let cleanedContent = content.replace(/\\(?:textit|textbf|textsc|textsl|emph)\s*\{/gi, (cmdMatch, offset) => {
                    // Logic to find the matching closing brace for THIS specific command
                    let depth = 1, j = offset + cmdMatch.length, inner = '';
                    while (j < content.length && depth > 0) {
                        if (content[j] === '{') depth++;
                        else if (content[j] === '}') { depth--; if (depth === 0) break; }
                        inner += content[j]; j++;
                    }
                    return inner;
                });

                // If the manual brace cleaning above is too complex, a simpler regex for flat structures:
                cleanedContent = cleanedContent.replace(/\\(?:textit|textbf|emph)\{([^}]*)\}/gi, '$1');

                // ── 2. Final Suggestion ──
                const suggestion = `"${cleanedContent}"`;

                // If no changes (e.g. already double quotes or no content), skip
                if (targetText === suggestion) continue;

                const position = getPositionFromIndex(texFile, targetIndex, targetText.length);

                if (isRejectedByLivePosition(position, this.name, targetText)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => {
                        if (old.originalText !== targetText) {
                            staleIds.add(old.id);
                        }
                    });
                    if (overlapping.every(old => old.originalText === targetText)) continue;
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions, targetText)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(
                        session,
                        Range,
                        position,
                        targetText,
                        suggestion,
                        this.markerClass,
                        this.name,
                        this.description,
                        anchorlist
                    );
                }
            }

            return staleIds;
        }
    },
    unitFormat: {
        name: "Unit Formatting",
        description: "Provides a non-breaking space between a number and a unit",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const pattern = /(\d+\$*\s?~*\.*)(m\.s|kg\.m|s|A|K|mol|cd|C|V|Ω|T|Wb|J|W|Pa|Hz|GHz|rad|sr|N|Wb|F|S|H|eV|u|Lx|lm|lx|Bq|Gy|Sv|kat|dB|kg|mm|m)(?!\w)/gm;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const num = match[1];
                const unit = match[2];
                const suggestion = `${num}\u00A0\\mathrm{${unit}}`;

                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position,
                        fullMatch, suggestion,
                        this.markerClass, this.name, this.description, anchorlist);
                }
            }

            return staleIds;
        }
    },

    latinPhrases: {
        name: "Latin Phrases Italics",
        description: "Convert latin phrases to italic format except etc which becomes roman.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();

            // ── Latin phrases → \textit{} ──
            const latinPattern = /\b(ad hoc|ad hominem|a posteriori|a priori|bona fide|carpe diem|de facto|de jure|exempli gratia|e\.g\.?|id est|i\.e\.?|in situ|in vitro|in vivo|ipso facto|mea culpa|modus operandi|per se|pro bono|quid pro quo|status quo|vice versa|ad infinitum|terra firma|curriculum vitae|alma mater|alter ego|deus ex machina|casus belli|et al\.?|per annum|per capita|persona non grata|vox populi|post mortem|in medias res|tabula rasa|magnum opus|sic semper tyrannis|veni vidi vici|sub rosa)\b/gmi;

            // ── etc → \textup{etc.} ──
            const etcPattern = /\betc\.?\b/gi;

            const processPattern = (pattern, buildSuggestion) => {
                let match;
                while ((match = pattern.exec(texFile)) !== null) {
                    const fullMatch = match[0];
                    const suggestion = buildSuggestion(fullMatch);

                    if (fullMatch === suggestion) continue;

                    // Skip if already wrapped in \textit or \textup
                    const before = texFile.slice(Math.max(0, match.index - 9), match.index);
                    if (before.endsWith('\\textit{') || before.endsWith('\\textup{')) continue;

                    const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                    if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                    if (overlapping.length > 0) {
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                    }

                    if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                        createAnchor(session, Range, position,
                            fullMatch, suggestion,
                            this.markerClass, this.name, this.description, anchorlist);
                    }
                }
            };

            processPattern(latinPattern, (m) => `\\textit{${m}}`);
            processPattern(etcPattern, (m) => `\\textup{etc.}`);

            return staleIds;
        }
    },

    replaceZeroBefore: {
        name: "Include Zero in Fraction",
        description: "Replace .5 to 0.5 — include 0 before fractions if missing.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const pattern = /(?<=\s|^)\.(\d+)/gm;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const suggestion = `0${fullMatch}`;
                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position,
                        fullMatch, suggestion,
                        this.markerClass, this.name, this.description, anchorlist);
                }
            }

            return staleIds;
        }
    },

    referencePlurals: {
        name: "Reference Plurals",
        description: "Make citations plural if more than one reference.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const pattern = /\b(reference)\s*(\[[0-9]+(?:[,\s;][0-9]+)+\])/gi;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const refWord = match[1];
                const citations = match[2];
                const suggestion = `${refWord}s ${citations}`;
                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position,
                        fullMatch, suggestion,
                        this.markerClass, this.name, this.description, anchorlist);
                }
            }

            return staleIds;
        }
    },

    hyphenToEnDash: {
        name: "Hyphen to En Dash in Table",
        description: "Change hyphens to en dashes within tables.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const tablePattern = /\\begin\{table\}([\s\S]*?)\\end\{table\}/g;
            let match;

            while ((match = tablePattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const tableContent = match[1];

                // ── Replace single hyphens with en dashes ──
                const newContent = tableContent.replace(/-/g, '--');
                const suggestion = `\\begin{table}${newContent}\\end{table}`;

                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                createAnchor(session, Range, position,
                    fullMatch, suggestion,
                    this.markerClass, this.name, this.description, anchorlist);
            }

            return staleIds;
        }
    },

    appendixToCapital: {
        name: "Appendix to Sentence Case",
        description: "Change the first letter of appendix text to capital.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const pattern = /\bappendix\b/g;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const suggestion = fullMatch.charAt(0).toUpperCase() + fullMatch.slice(1);

                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position,
                        fullMatch, suggestion,
                        this.markerClass, this.name, this.description, anchorlist);
                }
            }

            return staleIds;
        }
    },
    // typographyBasics: {
    //     name: "Basic Typography",
    //     description: "Remove double space and space before and after punctuation.",
    //     markerClass: "ace-Common-highlight",

    //     execute(texFile, session, Range, anchorlist,
    //         fileName, Allfiles,
    //         existingSuggestions = [],
    //         rejectedSuggestions = []) {
    //         const staleIds = new Set();
    //         const lines = texFile.split('\n');
    //         let index = 0;

    //         lines.forEach((line, lineNum) => {
    //             const lineStart = index;
    //             index += line.length + 1;

    //             let newLine = line
    //                 .replace(/\s{2,}/g, ' ')
    //                 .replace(/\s+([,.;:!?])/g, '$1')
    //                 .replace(/([,.;:!?])\s{2,}/g, '$1 ')
    //                 .replace(/\s+([\)\]\}"'])/g, '$1')
    //                 .replace(/([\(\[\{"'])\s+/g, '$1');

    //             if (newLine === line) return;

    //             const position = getPositionFromIndex(texFile, lineStart, line.length);

    //             if (isRejectedByLivePosition(position, this.name, line)) return;

    //             const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
    //             if (overlapping.length > 0) {
    //                 overlapping.forEach(old => staleIds.add(old.id));
    //             } else {
    //                 if (isAlreadyAnchored(position, this.name, existingSuggestions)) return;
    //             }

    //             if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
    //                 createAnchor(session, Range, position,
    //                     line, newLine,
    //                     this.markerClass, this.name, this.description, anchorlist);
    //             }
    //         });

    //         return staleIds;
    //     }
    // },

    listLevels: {
        name: "List Levelling",
        description: "Level lists safely with bullets, sentence casing after colon, punctuation.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const listPattern = /\\begin\{itemize\}([\s\S]*?)\\end\{itemize\}/g;
            let match;

            while ((match = listPattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                let block = match[1];

                // ── Level 1 ──
                block = block.replace(/(^|\n)\s*\\item\s+/g, '$1\\item[--] ');
                block = block.replace(/:\s*(\w)/g, (_, char) => `: ${char.toUpperCase()}`);
                block = block.replace(/;\s*(?=\S)/g, '; ');
                block = block.replace(/([^;]+)$/, m =>
                    m.trim().endsWith('.') ? m : m.trim() + '.'
                );

                // ── Level 2 ──
                block = block.replace(
                    /\\begin\{itemize\}([\s\S]*?)\\end\{itemize\}/g,
                    (m) => {
                        let inner = m;
                        inner = inner.replace(/(^|\n)\s*\\item\s+/g, '$1\\item[\\textbullet] ');
                        inner = inner.replace(/:\s*(\w)/g, (_, char) => `: ${char.toUpperCase()}`);
                        inner = inner.replace(/([^,]+)(,|$)/g, (_, item, sep) =>
                            item.trim() + (sep ? ',' : '.')
                        );
                        return inner;
                    }
                );

                // ── Level 3 ──
                block = block.replace(
                    /(\\begin\{itemize\}[\s\S]*?\\begin\{itemize\})([\s\S]*?)(\\end\{itemize\}[\s\S]*?\\end\{itemize\})/g,
                    (m) => {
                        let inner = m.replace(/(^|\n)\s*\\item\s+/g, '$1\\item[\\(\\circ\\)] ');
                        inner = inner.replace(/:\s*(\w)/g, (_, char) => `: ${char.toUpperCase()}`);
                        inner = inner.replace(/([^,]+)(,|$)/g, (_, item, sep) =>
                            item.trim() + (sep ? ',' : '.')
                        );
                        return inner;
                    }
                );

                const suggestion = `\\begin{itemize}${block}\\end{itemize}`;
                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                createAnchor(session, Range, position,
                    fullMatch, suggestion,
                    this.markerClass, this.name, this.description, anchorlist);
            }

            return staleIds;
        }
    },

    statementPlacement: {
        name: "Statement Placement",
        description: "Place statement values before reference and after acknowledgement.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();

            const ackRegex = /\\section\*?\{Acknowledgment\}[\s\S]*?(?=\\textcolor|\\section)/igm;
            const refRegex = /\\begin\{(thebibliography|bibliography)\}(\{\d+\})*/igm;
            const statementRegex = /(\\textcolor\{[^\}]*})?\{\\section\*?\{([^}]+)\}([\s\S]*?)(?=\\section|%*\\begin?\{thebibliography|bibliography\}|\\textcolor\{[^\}]*}\{?\\section)/gmsi;

            const order = [
                "Funding",
                "Conflicts of interest",
                "Data availability statement",
                "Author contribution statement",
                "Ethics approval",
                "Supplementary Material"
            ];

            // ── Collect all statements ──
            let tempFile = texFile;
            const statementsMap = {};

            tempFile = tempFile.replace(statementRegex, (match, _color, title, content) => {
                const key = title.trim().toLowerCase();
                statementsMap[key] = content.trim();
                return '';
            });

            const statementsBlock = order
                .map(title => {
                    const key = title.toLowerCase();
                    if (statementsMap[key]) {
                        return `\\section*{\\textbf{${title}}}\n${statementsMap[key]}`;
                    }
                    return null;
                })
                .filter(Boolean)
                .join('\n\n');

            if (!statementsBlock) return staleIds;

            // ── Find insertion point ──
            const ackMatch = tempFile.match(ackRegex);
            const refMatch = tempFile.match(refRegex);

            let insertIndex;
            if (ackMatch) {
                insertIndex = tempFile.indexOf(ackMatch[0]) + ackMatch[0].length;
            } else if (refMatch) {
                insertIndex = tempFile.indexOf(refMatch[0]);
            } else {
                insertIndex = tempFile.length;
            }

            const suggestion = tempFile.slice(0, insertIndex) +
                '\n\n' + statementsBlock + '\n\n' +
                tempFile.slice(insertIndex);

            if (texFile === suggestion) return staleIds;

            // ── Anchor the entire document as one replacement ──
            const position = {
                startRow: 0,
                startCol: 0,
                endRow: texFile.split('\n').length - 1,
                endCol: texFile.split('\n').pop().length
            };

            if (isRejectedByLivePosition(position, this.name, texFile)) return staleIds;

            const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
            if (overlapping.length > 0) {
                overlapping.forEach(old => staleIds.add(old.id));
            } else {
                if (isAlreadyAnchored(position, this.name, existingSuggestions)) return staleIds;
            }

            createAnchor(session, Range, position,
                texFile, suggestion,
                this.markerClass, this.name, this.description, anchorlist);

            return staleIds;
        }
    },
    titleCasing: {
        name: "Title to Caps",
        description: "Change the title to all caps",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const titlePattern = /\\title\s*\{/gi;
            let match;

            while ((match = titlePattern.exec(texFile)) !== null) {
                let depth = 1;
                let content = '';
                let i = match.index + match[0].length;

                // ── Extract content with brace matching ──
                while (i < texFile.length && depth !== 0) {
                    if (texFile[i] === '{') depth++;
                    if (texFile[i] === '}') { depth--; if (depth === 0) break; }
                    content += texFile[i];
                    i++;
                }

                const fullTag = `\\title{${content}}`;
                const suggestion = `\\title{${content.toUpperCase()}}`;

                if (fullTag === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullTag.length);

                if (isRejectedByLivePosition(position, this.name, fullTag)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(item => staleIds.add(item.id));  // ← .add not ()
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position,
                        fullTag, suggestion,
                        this.markerClass, this.name, this.description, anchorlist);
                }
            }

            return staleIds;
        }
    },
    checkCitationInList: {
        name: "Citation in reference check",
        description: "Check whether citations present in text are present in the reference list.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const citeRegex = /\\cite\{([^\}]*)\}/gm;
            const refRegex = /\\bibitem\{([^\}]*)\}/gm;
            const citationSet = new Set();
            const refSet = new Set();
            let res;

            while ((res = citeRegex.exec(texFile)) !== null) {
                res[1].split(',').forEach(item => citationSet.add(item.trim()));
            }
            while ((res = refRegex.exec(texFile)) !== null) {
                refSet.add(res[1].trim());
            }

            const missingInRef = [...citationSet].filter(c => !refSet.has(c));
            const notCited = [...refSet].filter(r => !citationSet.has(r));

            // ── Anchor each \cite{} that has no matching \bibitem ──
            if (missingInRef.length > 0) {
                const citePattern = /\\cite\{([^\}]*)\}/gm;
                let m;
                while ((m = citePattern.exec(texFile)) !== null) {
                    const keys = m[1].split(',').map(k => k.trim());
                    const missing = keys.filter(k => missingInRef.includes(k));
                    if (missing.length === 0) continue;

                    const fullMatch = m[0];
                    const position = getPositionFromIndex(texFile, m.index, fullMatch.length);

                    if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                    if (overlapping.length > 0) {
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                    }

                    createAnchor(session, Range, position,
                        fullMatch, fullMatch,
                        this.markerClass, this.name,
                        `\\cite{${missing.join(', ')}} has no matching \\bibitem`,
                        anchorlist,
                        { queryOnly: true });
                }
            }

            // ── Anchor each \bibitem{} that is never cited ──
            if (notCited.length > 0) {
                const bibPattern = /\\bibitem\{([^\}]*)\}/gm;
                let m;
                while ((m = bibPattern.exec(texFile)) !== null) {
                    const key = m[1].trim();
                    if (!notCited.includes(key)) continue;

                    const fullMatch = m[0];
                    const position = getPositionFromIndex(texFile, m.index, fullMatch.length);

                    if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                    if (overlapping.length > 0) {
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                    }

                    createAnchor(session, Range, position,
                        fullMatch, fullMatch,
                        this.markerClass, this.name,
                        `\\bibitem{${key}} is never cited in text`,
                        anchorlist,
                        { queryOnly: true });
                }
            }

            return staleIds;
        }
    },

    removeVerticalLinesInTable: {
        name: "Remove Table Vertical Lines",
        description: "Removes vertical lines in tables from column definition.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const pattern = /\\begin\{tabular\}\{([^\}]*)\}/g;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const columns = match[1];
                const cleanCols = columns.replace(/\|/g, '');
                const suggestion = `\\begin{tabular}{${cleanCols}}`;

                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position,
                        fullMatch, suggestion,
                        this.markerClass, this.name, this.description, anchorlist);
                }
            }

            return staleIds;
        }
    },

    orderCheck: {
        name: "Section Order Enforcement",
        description: "Ensures correct order: Acknowledgments → Statements → References → Citation box → Appendices.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();

            const ackRegex = /\\section\*?\{Acknowledg?ments?\}[\s\S]*?(?=(\\section|\%*\\begin\{thebibliography\}|\\bibliography|\\appendix|$))/i;
            const statementsRegex = /(\\textcolor\{[^\}]*}\{)?\\section\*?\{(Data\s*Availability|Funding|Conflict|Author|Ethics|Supplementary)[\s\S]*?(?=(\\section|\%*\\begin\{thebibliography\}|\\bibliography|\\appendix|$))/gi;
            const referencesRegex = /(\\begin\{thebibliography\}[\s\S]*?\\end\{thebibliography\})|(\\bibliography\{[^\}]*\})/i;
            const citationBoxRegex = /\\begin\{citationbox\}[\s\S]*?\\end\{citationbox\}/i;
            const appendicesRegex = /(\\appendix|\\section\*?\{Appendix[^\}]*\})[\s\S]*/i;

            const sections = {
                ack: texFile.match(ackRegex)?.[0] || '',
                statements: (texFile.match(statementsRegex) || []).join('\n'),
                references: texFile.match(referencesRegex)?.[0] || '',
                citationBox: texFile.match(citationBoxRegex)?.[0] || '',
                appendices: texFile.match(appendicesRegex)?.[0] || ''
            };

            const orderedBlock = [
                sections.ack,
                sections.statements,
                sections.references,
                sections.citationBox,
                sections.appendices
            ].filter(Boolean).join('\n\n');

            if (!orderedBlock) return staleIds;

            // ── Remove old occurrences and reinsert in correct order ──
            let suggestion = texFile
                .replace(ackRegex, '')
                .replace(statementsRegex, '')
                .replace(referencesRegex, '')
                .replace(citationBoxRegex, '')
                .replace(appendicesRegex, '');

            suggestion += '\n' + orderedBlock;

            if (texFile === suggestion) return staleIds;

            const position = getPositionFromIndex(texFile, 0, texFile.length);

            if (isRejectedByLivePosition(position, this.name, texFile)) return staleIds;

            const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
            if (overlapping.length > 0) {
                overlapping.forEach(old => staleIds.add(old.id));
            } else {
                if (isAlreadyAnchored(position, this.name, existingSuggestions)) return staleIds;
            }

            createAnchor(session, Range, position,
                texFile, suggestion,
                this.markerClass, this.name, this.description, anchorlist);

            return staleIds;
        }
    },

    referenceFormatter: {
        name: "Reference Cleanup and Formatting",
        description: "Validates and formats the reference section with consistent structure and typography.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const bibRegex = /\\bibitem\{([^\}]*)\}([\p{L}\d\.\s\-\\']+(?:,\s*[\p{L}\d\.\s\-\\']+)*(?:\s+and\s*[\p{L}\d\.\s\-\\']*)?),(\n*.*?(?=\n*))\n([\\textit]*\{[^\}]*\})*\s*([\\textbf]*\{\d+\})*(?:\s*\((\d+)\)(?=\s*\(\d{4}\)))?(?:\s*\(?(\d{4})\)?)?\s*(\w*\d+(?:--\w*\d+)?)?/gmu;
            let res;

            while ((res = bibRegex.exec(texFile)) !== null) {
                let [fullMatch, key, authors, title, journal, volume, issue, year, pages] = res;

                const missing = [];
                if (!authors) missing.push('authors');
                if (!title) missing.push('title');
                if (!journal) missing.push('journal');
                if (!volume) missing.push('volume');
                if (!year) missing.push('year');
                if (!pages) missing.push('pages');

                if (title) title = title.trim().replace(/\\textit\{([^\}]*)\}/g, '$1');
                if (journal) {
                    journal = journal.trim().replace(/^\\textit\{([^\}]*)\}$/g, '$1');
                    journal = journal.replace(/^(.)/, c => c.toUpperCase());
                    journal = `\\textit{${journal}}`;
                } else {
                    journal = '';
                }
                if (volume) {
                    volume = volume.trim().replace(/^\\textbf\{([^\}]*)\}$/g, '$1');
                    volume = `\\textbf{${volume}}`;
                }
                if (year) {
                    year = year.trim();
                    if (!/^\(.*\)/.test(year)) year = `(${year})`;
                }
                if (pages) pages = pages.replace(/(?<!-)-/g, '--');

                const suggestion = `\\bibitem{${key}}` +
                    (authors ? authors + ',\n' : '') +
                    (title ? title + '\n' : '') +
                    (journal ? journal + ' ' : '') +
                    (volume ? volume + ' ' : '') +
                    (year ? year + ' ' : '') +
                    (pages ? pages : '') +
                    (missing.length ? `\n\\AQ{Missing elements: ${missing.join(',')}}` : '');

                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, res.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position,
                        fullMatch, suggestion,
                        this.markerClass, this.name, this.description, anchorlist);
                }
            }

            return staleIds;
        }
    },
    uncitedReferences: {
        name: "Uncited References",
        description: "Captures references not cited in body and places them under uncited references heading.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const refKey = /\\bibitem\{([^\}]*)\}(\n*.*?)(?=\\bibitem|\\end\{thebibliography\})/gmsu;
            const refCite = /\\cite\{([^\}]*)\}/gum;
            let ref;
            const cite = new Set();
            const referenceKeys = [];
            const noncited = [];

            while ((ref = refCite.exec(texFile)) !== null) {
                ref[1].split(',').forEach(i => cite.add(i.trim()));
            }
            while ((ref = refKey.exec(texFile)) !== null) {
                if (![...cite].includes(ref[1])) noncited.push(ref[0]);
                referenceKeys.push(ref[1]);
            }

            // ── 1. Anchor each \cite{} with missing reference ──
            cite.forEach(c => {
                if (!referenceKeys.includes(c)) {
                    const citePattern = new RegExp(
                        `\\\\cite\\{(?:,*[^}]*)?${c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(?:,[^}]*)?\\}`, 'g'
                    );
                    let m;
                    while ((m = citePattern.exec(texFile)) !== null) {
                        const fullMatch = m[0];
                        const suggestion = `${fullMatch} \\AQ{Reference is missing for the citation ${c}.}`;
                        const position = getPositionFromIndex(texFile, m.index, fullMatch.length);

                        if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                        const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                        if (overlapping.length > 0) {
                            overlapping.forEach(old => staleIds.add(old.id));
                        } else {
                            if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                        }

                        createAnchor(session, Range, position,
                            fullMatch, suggestion,
                            this.markerClass, this.name,
                            `Reference missing for \\cite{${c}}`,
                            anchorlist);
                    }
                }
            });

            // ── 2. Anchor \end{document} to insert uncited references before it ──
            if (noncited.length > 0) {
                const endDocPattern = /\\end\{document\}/g;
                let m;
                while ((m = endDocPattern.exec(texFile)) !== null) {
                    const fullMatch = m[0];
                    const suggestion = `\\title{Uncited References}\n\n${noncited.join('\n\n')}\n\\end{document}`;
                    const position = getPositionFromIndex(texFile, m.index, fullMatch.length);

                    if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                    if (overlapping.length > 0) {
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                    }

                    createAnchor(session, Range, position,
                        fullMatch, suggestion,
                        this.markerClass, this.name,
                        `Insert ${noncited.length} uncited reference(s) before \\end{document}`,
                        anchorlist);
                }
            }

            return staleIds;
        }
    },

    mathToRoman: {
        name: "Math Functions to Roman",
        description: "Convert math functions like sin, cos, tan etc to roman.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const functions = ["cos", "sin", "tan", "exp", "log", "lim", "Tr", "det"];
            const funcRegex = new RegExp(`\\b(${functions.join('|')})\\b`, 'g');
            const equationPattern = /\\begin\{equation\}([\s\S]*?)\\end\{equation\}/g;
            let match;

            while ((match = equationPattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const inner = match[1];
                const newInner = inner.replace(funcRegex, fn => `\\mathrm{${fn}}`);
                const suggestion = `\\begin{equation}${newInner}\\end{equation}`;

                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                createAnchor(session, Range, position,
                    fullMatch, suggestion,
                    this.markerClass, this.name, this.description, anchorlist);
            }

            return staleIds;
        }
    },

    energyToRoman: {
        name: "Energy Level to Roman",
        description: "Convert energy level occurrences inside the document into roman.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const pattern = /\b\d+[A-Z]\d*[a-z]?\b/g;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const suggestion = `\\mathrm{${fullMatch}}`;
                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position,
                        fullMatch, suggestion,
                        this.markerClass, this.name, this.description, anchorlist);
                }
            }

            return staleIds;
        }
    },

    spacing: {
        name: "Provide Spacing",
        description: "Provides spacing to various elements per rule sheet.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const lines = texFile.split('\n');
            let index = 0;
            const si = ["m", "cm", "mm", "kg", "g", "s", "A", "K", "mol", "cd", "N", "J", "W", "Pa", "V", "Hz"];
            const siRegex = new RegExp(`(\\d)\\s*(${si.join('|')})(?!\\.)\\b`, 'g');

            lines.forEach((line) => {
                const lineStart = index;
                index += line.length + 1;

                let newLine = line
                    .replace(/(\d)\s*°\s*(?=[A-Za-z])/g, '$1 °')
                    .replace(/(\d)\s*°/g, '$1° ')
                    .replace(/(\d)\s*′/g, '$1′ ')
                    .replace(/(\d)\s*″/g, '$1″ ')
                    .replace(/\s*&\s*/g, ' & ')
                    .replace(/(\d)\s*\/\s*(\d)/g, ' $1/$2')
                    .replace(/(\d)(st|nd|rd|th)(?!\w)/g, '$1$2 ')
                    .replace(/(\d)\s*([+\-×÷])\s*(\d)/g, ' $1 $2 $3 ')
                    .replace(/(\d)\s*%/g, '$1% ')
                    .replace(siRegex, '$1 $2 ')
                    .replace(/\s*([$₹€£])\s*(\d)/g, '$1$2 ');

                if (newLine === line) return;

                const position = getPositionFromIndex(texFile, lineStart, line.length);

                if (isRejectedByLivePosition(position, this.name, line)) return;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) return;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position,
                        line, newLine,
                        this.markerClass, this.name, this.description, anchorlist);
                }
            });

            return staleIds;
        }
    },

    figToPlural: {
        name: "Fig to Plural",
        description: "Convert figure ref to plural if more than one figure ref present.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const pattern = /\\figref\{([^}]*)\}/g;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const inside = match[1];
                const cleaned = inside.replace(/\s*,\s*/g, ',').replace(/\s*-\s*/g, '-');
                const parts = cleaned.split(',');

                let count = 0;
                parts.forEach(p => {
                    if (p.includes('-')) count += 2;
                    else count++;
                });

                if (count <= 1) continue;

                const updated = cleaned.replace(/^([fig|figure]*)/, '$1s');
                const suggestion = `\\figref{${updated}}`;

                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                createAnchor(session, Range, position,
                    fullMatch, suggestion,
                    this.markerClass, this.name, this.description, anchorlist);
            }

            return staleIds;
        }
    },

    citeInFigure: {
        name: "Citation in Figure",
        description: "Citation present in figure but not anywhere else in the text.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const figurePattern = /\\begin\{figure\}([\s\S]*?)\\end\{figure\}/g;
            const captionPattern = /\\caption\{((?:[^{}]*(?:\{(?:[^{}]*(?:\{(?:[^{}]*(?:\{[^{}]*\})*[^{}]*)*\})*[^{}]*)*\})*[^{}]*)*)\}/g;
            const citePattern = /\\cite\{([^}]*)\}/g;
            let figMatch;

            while ((figMatch = figurePattern.exec(texFile)) !== null) {
                const figFull = figMatch[0];
                const figStart = figMatch.index;
                let capMatch;

                captionPattern.lastIndex = 0;
                while ((capMatch = captionPattern.exec(figFull)) !== null) {
                    const capFull = capMatch[0];
                    const capContent = capMatch[1];
                    const capAbsIdx = figStart + figMatch[0].indexOf(capFull);

                    let citeM;
                    citePattern.lastIndex = 0;

                    while ((citeM = citePattern.exec(capContent)) !== null) {
                        const citeFull = citeM[0];
                        const keys = citeM[1].split(',').map(k => k.trim());

                        const hasSingleOccurrence = keys.some(k => {
                            const occurrences = (texFile.match(
                                new RegExp(`\\\\cite\\{[^}]*\\b${k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b[^}]*\\}`, 'g')
                            ) || []);
                            return occurrences.length === 1;
                        });

                        if (!hasSingleOccurrence) continue;

                        const citeAbsIdx = capAbsIdx +
                            capFull.indexOf(capContent) +
                            citeM.index;

                        const suggestion = `${citeFull} \\AQ{The reference is not cited in the text.}`;
                        const position = getPositionFromIndex(texFile, citeAbsIdx, citeFull.length);

                        if (isRejectedByLivePosition(position, this.name, citeFull)) continue;

                        const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                        if (overlapping.length > 0) {
                            overlapping.forEach(old => staleIds.add(old.id));
                        } else {
                            if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                        }

                        createAnchor(session, Range, position,
                            citeFull, suggestion,
                            this.markerClass, this.name,
                            'Citation in figure not cited in text',
                            anchorlist);
                    }
                }
            }

            return staleIds;
        }
    },
    checkFigureForLegend: {
        name: "Figure Legend Check",
        description: "Checks whether the figure has a legend present in it.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const figurePattern = /\\begin\{figure\}([\s\S]*?)\\end\{figure\}/g;
            let match;

            while ((match = figurePattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const hasCaption = /\\caption\{[\s\S]*?\}/.test(fullMatch);

                if (hasCaption) continue;

                // ── Anchor the \begin{figure} line as a query ──
                const firstNewline = fullMatch.indexOf('\n');
                const firstLine = firstNewline !== -1
                    ? fullMatch.slice(0, firstNewline)
                    : fullMatch;

                const position = getPositionFromIndex(texFile, match.index, firstLine.length);

                if (isRejectedByLivePosition(position, this.name, firstLine)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                createAnchor(session, Range, position,
                    firstLine, firstLine,
                    this.markerClass, this.name,
                    'Legend (\\caption) missing in this figure',
                    anchorlist,
                    { queryOnly: true });
            }

            return staleIds;
        }
    },

    citationInAbstract: {
        name: "Citation in Abstract",
        description: "Check for citations in abstract and replace \\cite with its title.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const abstractPattern = /\\begin\{abstract\}([\s\S]*?)\\end\{abstract\}/m;
            const absMatch = abstractPattern.exec(texFile);
            if (!absMatch) return staleIds;

            const abstractContent = absMatch[1];
            const abstractStart = absMatch.index;

            // ── Build titleMap from \bibitem entries ──
            const bibRegex = /\\bibitem\{([^\}]*)\}([\p{L}\d\.\s\-\\']+(?:,\s*[\p{L}\d\.\s\-\\']+)*(?:\s+and\s*[\p{L}\d\.\s\-\\']*)?),(\n*.*?(?=\n*))\n([\\textit]*\{[^\}]*\})*\s*([\\textbf]*\{\d+\})*(?:\s*\((\d+)\)(?=\s*\(\d{4}\)))?(?:\s*\(?(\d{4})\)?)?\s*(\w*\d+(?:--\w*\d+)?)?/gmu;
            const titleMap = {};
            let bm;
            while ((bm = bibRegex.exec(texFile)) !== null) {
                const key = bm[1];
                const title = bm[3]?.trim();
                if (key && title) titleMap[key] = title;
            }

            // ── Text outside abstract for checking presence ──
            const before = texFile.slice(0, abstractStart);
            const after = texFile.slice(abstractStart + absMatch[0].length);
            const outsideText = before + after;

            // ── Find all \cite{} inside abstract ──
            const citePattern = /\\cite\{([^}]+)\}/g;
            let citeM;

            while ((citeM = citePattern.exec(abstractContent)) !== null) {
                const fullMatch = citeM[0];
                const keys = citeM[1].split(',').map(k => k.trim());

                // ── Build replacement from titleMap ──
                const titles = keys.map(k => titleMap[k] || k);
                const suggestion = titles.join('; ');

                // ── Absolute index in texFile ──
                const absIdx = abstractStart +
                    absMatch[0].indexOf(abstractContent) +
                    citeM.index;

                const position = getPositionFromIndex(texFile, absIdx, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                createAnchor(session, Range, position,
                    fullMatch, suggestion,
                    this.markerClass, this.name,
                    `Replace \\cite{${citeM[1]}} with title in abstract`,
                    anchorlist);


                const notOutside = keys.some(k => {
                    const pat = new RegExp(
                        `\\\\cite\\{[^}]*\\b${k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b[^}]*\\}`, 'g'
                    );
                    return !pat.test(outsideText);
                });

                if (notOutside) {
                    const queryPosition = getPositionFromIndex(texFile, absIdx, fullMatch.length);
                    createAnchor(session, Range, queryPosition,
                        fullMatch, fullMatch,
                        this.markerClass, this.name,
                        `Citation \\cite{${citeM[1]}} not found outside abstract`,
                        anchorlist,
                        { queryOnly: true });
                }
            }

            return staleIds;
        }
    },
    DecimalFormatting: {
        name: "Decimal Formatting",
        description: "Replace decimals like '.5' with '0.5'.",
        markerClass: "ace-Common-highlight",

        // Use standard function syntax so 'this' refers to the DecimalFormatting object
        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {

            const staleIds = new Set();

            // Logic: Match a '.' followed by digits, but ONLY if NOT preceded by another digit
            // This ensures we don't turn 12.5 into 120.5
            const decimalPattern = /(^|[^\d])(\.\d+)/g;
            let match;

            while ((match = decimalPattern.exec(texFile)) !== null) {
                // match[1] is the boundary (space or non-digit)
                // match[2] is the actual decimal (e.g., ".5")
                const prefix = match[1];
                const decimalPart = match[2];

                const fullMatch = match[0];
                const suggestion = `${prefix}0${decimalPart}`;

                // Calculate position for the match
                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                // Use 'this.name' safely now
                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => {
                        if (old.originalText !== fullMatch) {
                            staleIds.add(old.id);
                        }
                    });
                    if (overlapping.every(old => old.originalText === fullMatch)) continue;
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions, fullMatch)) continue;
                }

                // Ensure we aren't in a commented line
                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(
                        session,
                        Range,
                        position,
                        fullMatch,
                        suggestion,
                        this.markerClass,
                        this.name,
                        this.description,
                        anchorlist
                    );
                }
            }

            return staleIds;
        }
    },
    numberSentenceStart: {
        name: "Numbers at Sentence Start",
        description: "Spell out numbers and units when they start a sentence.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {

            const staleIds = new Set();

            // Replaced Lookbehind with a Non-capturing group for better compatibility
            const pattern = /(?:^|[.?!]\s+|\n+)(\d+)\s+([a-z]+)/gi;
            let match;

            const unitSpelling = {
                "kg": "kilograms", "m": "meters", "s": "seconds",
                "cm": "centimeters", "km": "kilometers", "g": "grams",
                "ml": "milliliters", "l": "liters"
            };

            while ((match = pattern.exec(texFile)) !== null) {
                let fullMatch = match[0];
                const numValue = parseInt(match[1]);
                const unitAbbr = match[2].toLowerCase();

                // Because the regex now includes the preceding space/punctuation in match[0],
                // we calculate the exact start of the NUMBER itself.
                const numberPart = match[1] + " " + match[2];
                const offset = fullMatch.indexOf(match[1]);
                const actualIndex = match.index + offset;

                if (unitSpelling[unitAbbr]) {
                    let spelledNumber = numberToWords(numValue);
                    spelledNumber = spelledNumber.charAt(0).toUpperCase() + spelledNumber.slice(1);

                    const spelledUnit = unitSpelling[unitAbbr];
                    const suggestion = `${spelledNumber} ${spelledUnit}`;

                    // Position should only cover the number and unit, not the preceding space
                    const position = getPositionFromIndex(texFile, actualIndex, numberPart.length);

                    if (isRejectedByLivePosition(position, this.name, numberPart)) continue;

                    // Inside your execute loop in the style object:
                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);

                    if (overlapping.length > 0) {
                        overlapping.forEach(old => {
                            // If the text is the same, but the marker is missing from the session
                            if (old.originalText === fullMatch) {
                                // CHECK: Does this anchor have a valid marker in the current session?
                                // If the CSS is gone but the anchor exists, re-add the marker.
                                if (!session.getMarkers()[old.markerId]) {
                                    old.markerId = session.addMarker(
                                        new Range(position.startRow, position.startCol, position.endRow, position.endCol),
                                        this.markerClass,
                                        "text"
                                    );
                                }
                            } else {
                                staleIds.add(old.id);
                            }
                        });
                        if (overlapping.every(old => old.originalText === fullMatch)) continue;
                    } else {
                        if (isAlreadyAnchored(position, this.name, existingSuggestions, numberPart)) continue;
                    }

                    if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                        createAnchor(
                            session, Range, position,
                            numberPart, // originalText
                            suggestion, // suggestedText
                            this.markerClass, this.name, this.description,
                            anchorlist
                        );
                    }
                }
            }
            return staleIds;
        }
    },

    listLevelSymbols: {
        name: "List Level Symbols",
        description: "Sets 1st level: en-dash, 2nd: black bullet, 3rd: empty bullet.",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();

            const suggestion =
                "\\renewcommand{\\labelitemi}{--}\n" +
                "\\renewcommand{\\labelitemii}{$\\bullet$}\n" +
                "\\renewcommand{\\labelitemiii}{$\\circ$}\n\n";

            // 1. Exit if the work is already done
            if (texFile.includes("\\renewcommand{\\labelitemi}{--}")) return staleIds;

            // 2. Find the target (\begin{document})
            const match = /\\begin\{document\}/i.exec(texFile);
            if (!match) return staleIds;

            // 3. Calculate position (We anchor to the "\begin{document}" text)
            const titlePos = getPositionFromIndex(texFile, match.index, match[0].length);
            const position = {
                startRow: titlePos.startRow,
                startCol: titlePos.startCol,
                endRow: titlePos.endRow,
                endCol: titlePos.endCol,
            };

            // 4. Check for rejections
            if (isRejectedByLivePosition(position, this.name, match[0])) return staleIds;

            // 5. Overlap Logic (MATCHING PREAMBLE INSERTION)
            const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
            if (overlapping.length > 0) {
                // If it exists, mark it as stale so it can be re-created/refreshed
                overlapping.forEach(old => staleIds.add(old.id));
            } else {
                // If no overlap, check if it's already anchored elsewhere
                if (isAlreadyAnchored(position, this.name, existingSuggestions)) return staleIds;
            }

            // 6. Create Anchor
            createAnchor(
                session, Range,
                position,
                match[0],        // originalText (the \begin{document} part)
                suggestion,      // suggestionText
                this.markerClass,
                this.name,
                this.description,
                anchorlist,
                {
                    isListLevelInsertion: true,
                    matchIndex: match.index // Extra info for the action
                }
            );

            return staleIds;
        }
    },
    listItemCasing: {
        name: "List Item Casing",
        description: "Ensures list items start with a capital letter.",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();
            // 1. Reset Regex and capture the first word where the first letter is lowercase
            // ([a-z][^\s\\]*) captures a lowercase letter followed by non-space/non-slash chars
            const pattern = /\\item\s+([a-z][^\s\\]*)/g;
            pattern.lastIndex = 0;

            let match;
            while ((match = pattern.exec(texFile)) !== null) {
                const fullWord = match[1];
                const suggestion = fullWord.charAt(0).toUpperCase() + fullWord.slice(1);

                // 2. Calculate position of the full word
                // We find exactly where the word starts relative to the match
                const wordOffset = match[0].indexOf(fullWord);
                const actualIndex = match.index + wordOffset;
                const pos = getPositionFromIndex(texFile, actualIndex, fullWord.length);

                const position = {
                    startRow: pos.startRow,
                    startCol: pos.startCol,
                    endRow: pos.endRow,
                    endCol: pos.endCol,
                };

                // 3. Overlap Logic (Following the Preamble pattern to prevent disappearing)
                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    // Mark as stale to refresh the UI on every keystroke
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions, fullWord)) continue;
                }

                // 4. Create Anchor for the WHOLE word
                createAnchor(
                    session, Range,
                    position,
                    fullWord,     // originalText (e.g., "apple")
                    suggestion,   // suggestionText (e.g., "Apple")
                    this.markerClass,
                    this.name,
                    this.description,
                    anchorlist
                );
            }
            return staleIds;
        }
    },
    listSeparators: {
        name: "List Separator Endings",
        description: "Semicolons for items, Full stop for the last item.",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();
            // 1. Define and Reset Regex
            const pattern = /\\item\s+([\s\S]*?)(?=\s*\\item|\s*\\end\{itemize\}|\s*$)/g;
            pattern.lastIndex = 0;

            let match;
            while ((match = pattern.exec(texFile)) !== null) {
                let fullBlock = match[1];

                // 2. Locate comments to ignore them
                const commentMatch = /(?<!\\)%/.exec(fullBlock);
                const commentStart = commentMatch ? commentMatch.index : -1;
                let textBeforeComment = commentStart !== -1 ? fullBlock.slice(0, commentStart) : fullBlock;
                let trimmedText = textBeforeComment.trimEnd();

                if (!trimmedText || trimmedText.includes('\\begin{itemize}')) continue;

                const lastChar = trimmedText.slice(-1);
                const remainingText = texFile.substring(match.index + match[0].length).trimStart();
                const isLast = remainingText.startsWith("\\end{itemize}") || !remainingText.includes("\\item");
                const expected = isLast ? "." : ";";

                if (lastChar !== expected) {
                    // 3. Calculate position at the end of the text (before spaces/comments)
                    const offsetInBlock = fullBlock.lastIndexOf(trimmedText) + trimmedText.length - 1;
                    const actualIndex = match.index + (match[0].indexOf(fullBlock)) + offsetInBlock;
                    const pos = getPositionFromIndex(texFile, actualIndex, 1);

                    const isPunct = /[;,\.]/.test(lastChar);
                    const originalText = lastChar;
                    const suggestedText = isPunct ? expected : lastChar + expected;

                    // 4. Overlap Logic (Following the Preamble pattern)
                    const overlapping = getOverlappingAnchors(pos, this.name, existingSuggestions);
                    if (overlapping.length > 0) {
                        // Always add to staleIds to ensure the anchor is refreshed
                        overlapping.forEach(old => {
                            // If it's the exact same suggestion, we still refresh it to prevent flickering
                            staleIds.add(old.id);
                        });
                    } else {
                        if (isAlreadyAnchored(pos, this.name, existingSuggestions, originalText)) continue;
                    }

                    // 5. Create Anchor
                    createAnchor(
                        session, Range, pos,
                        originalText,
                        suggestedText,
                        this.markerClass,
                        this.name,
                        this.description,
                        anchorlist
                    );
                }
            }
            return staleIds;
        }
    },
    mathFunctionsRoman: {
        name: "Math Functions in Roman",
        description: "Remove \\textit{} around math functions (cos, sin, tan, etc.).",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();
            // 1. Define common math functions that should be Roman (not italic)
            const mathFunctions = ["cos", "sin", "tan", "exp", "log", "lim", "Tr", "det"];

            // 2. Target \textit{...} blocks
            const pattern = /\\textit\{([^}]*?)\}/g;
            pattern.lastIndex = 0; // Essential to prevent the 2-keystroke flicker

            let match;
            while ((match = pattern.exec(texFile)) !== null) {
                const content = match[1];
                const originalText = match[0];

                // 3. Precise Check: Does the content contain one of the math functions?
                // We check for word boundaries to avoid matching "cost" for "cos"
                const hasMathFunc = mathFunctions.some(func => {
                    const regex = new RegExp(`\\b${func}\\b`);
                    return regex.test(content);
                });

                if (hasMathFunc) {
                    const suggestionText = content;
                    const pos = getPositionFromIndex(texFile, match.index, originalText.length);

                    const position = {
                        startRow: pos.startRow,
                        startCol: pos.startCol,
                        endRow: pos.endRow,
                        endCol: pos.endCol,
                    };

                    // 4. Overlap Logic (The "Refresh" Strategy)
                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                    if (overlapping.length > 0) {
                        // Mark old IDs as stale to trigger a fresh redraw of the dotted line
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        // Check if already anchored or rejected
                        if (isAlreadyAnchored(position, this.name, existingSuggestions, originalText)) continue;
                        if (isRejectedByLivePosition(position, this.name, originalText)) continue;
                    }

                    // 5. Create/Renew Anchor
                    createAnchor(
                        session, Range, position,
                        originalText, suggestionText,
                        this.markerClass, this.name, this.description,
                        anchorlist
                    );
                }
            }
            return staleIds;
        }
    },

    // ordinalNumbers: {
    //     name: "Ordinal Numbers Format",
    //     description: "Ensure st, nd, rd, th are on the line and attached to digits/variables.",
    //     markerClass: "ace-Common-highlight",
    //     execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
    //         const staleIds = new Set();
    //         // Matches numbers/variables followed by ordinals in superscript or with spaces
    //         // e.g., 1^{st}, 1 \textsuperscript{st}, 1 st
    //         const pattern = /(\d|[a-zA-Z])(?:\s+|\^|\\textsuperscript)\{?\s*(st|nd|rd|th)\b\}?/gi;
    //         pattern.lastIndex = 0;

    //         let match;
    //         while ((match = pattern.exec(texFile)) !== null) {
    //             const fullMatch = match[0];
    //             const base = match[1];
    //             const suffix = match[2].toLowerCase();
    //             const suggestion = `${base}${suffix}`;

    //             const pos = getPositionFromIndex(texFile, match.index, fullMatch.length);
    //             const overlapping = getOverlappingAnchors(pos, this.name, existingSuggestions);

    //             if (overlapping.length > 0) {
    //                 overlapping.forEach(old => staleIds.add(old.id));
    //             } else {
    //                 if (isAlreadyAnchored(pos, this.name, existingSuggestions, fullMatch)) continue;
    //             }

    //             createAnchor(session, Range, pos, fullMatch, suggestion,
    //                 this.markerClass, this.name, this.description, anchorlist);
    //         }
    //         return staleIds;
    //     }
    // },
    ordinalNumbers: {
        name: "Ordinal Numbers Format",
        description: "Convert superscript or spaced ordinals (1^{st}, n th) to inline text (1st, nth).",
        markerClass: "ace-Common-highlight",
        beforeImage: "/images/description/OrdinalNumbersBefore.png",
        afterImage: "/images/description/OrdinalNumbersAfter.png",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {

            const staleIds = new Set();

            // This pattern captures:
            // 1. A digit or a letter: (\d|[a-zA-Z])
            // 2. Optional math delimiters, spaces, carets, or \textsuperscript: (?:\$?\s*\^?\$?\s*|\\textsuperscript)
            // 3. Optional braces and LaTeX font commands: \{?\s*(?:\\rm\s+|\\?text\{)?
            // 4. The actual ordinal suffix: (st|nd|rd|th)
            // 5. Closing braces and optional math delimiter: \s*\}?\}?\$?
            const aggressivePattern = /(\d|[a-zA-Z])(?:\$?\s*\^?\$?\s*|\\textsuperscript)\{?\s*(?:\\rm\s+|\\?text\{)?(st|nd|rd|th)\b\s*\}?\}?\$?/gi;

            let match;
            while ((match = aggressivePattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const base = match[1];
                const suffix = match[2].toLowerCase();
                const suggestion = `${base}${suffix}`;

                const pos = getPositionFromIndex(texFile, match.index, fullMatch.length);

                // Safety Checks
                if (isRejectedByLivePosition(pos, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(pos, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(pos, this.name, existingSuggestions)) continue;
                }

                // Don't trigger if this is inside a LaTeX command definition (e.g. \newcommand{\1st})
                if (typeof findCommandorNot === 'function' && findCommandorNot(pos.startRow, pos.startCol, texFile)) {
                    continue;
                }

                createAnchor(
                    session, Range, pos,
                    fullMatch, suggestion,
                    this.markerClass, this.name, this.description,
                    anchorlist
                );
            }

            return staleIds;
        }
    },
    standardSpacing: {
        name: "Typesetting Spacing",
        description: "Ensures correct spacing for Degrees, Percentages, and Units.",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();
            // Pattern 1: Percentage (10% -> 10 %)
            // Pattern 2: Degree (10° -> 10 °)
            // Pattern 3: SI Units (10kg -> 10 kg)
            const rules = [
                { regex: /(\d)(%)/g, build: (m, g1, g2) => `${g1} ${g2}` },
                { regex: /(\d)(°)/g, build: (m, g1, g2) => `${g1} ${g2}` },
                { regex: /(\d)(kg|mg|ml|km|cm|mm|ms|GeV|MeV)\b/g, build: (m, g1, g2) => `${g1} ${g2}` }
            ];

            rules.forEach(rule => {
                rule.regex.lastIndex = 0;
                let match;
                while ((match = rule.regex.exec(texFile)) !== null) {
                    const fullMatch = match[0];
                    const suggestion = rule.build(match, match[1], match[2]);

                    const pos = getPositionFromIndex(texFile, match.index, fullMatch.length);
                    const overlapping = getOverlappingAnchors(pos, this.name, existingSuggestions);

                    if (overlapping.length > 0) {
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        if (isAlreadyAnchored(pos, this.name, existingSuggestions, fullMatch)) continue;
                    }

                    createAnchor(session, Range, pos, fullMatch, suggestion,
                        this.markerClass, this.name, this.description, anchorlist);
                }
            });

            return staleIds;
        }
    },

    latinPhrasesRoman: {
        name: "Latin Phrases in Roman",
        description: "Remove \\textit{} wrapper from Latin phrases (ad hoc, in situ, etc.).",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();

            // 1. Define the list of Latin phrases to target
            const latinWords = [
                "ad hoc", "ad hominem", "a posteriori", "a priori", "bona fide",
                "de facto", "de jure", "et al.", "e.g.", "i.e.", "in situ",
                "in vitro", "in vivo", "per se", "status quo", "vice versa"
            ];

            // 2. Target \textit{...} blocks
            const pattern = /\\textit\{([^}]*?)\}/g;
            pattern.lastIndex = 0;

            let match;
            while ((match = pattern.exec(texFile)) !== null) {
                const content = match[1];
                const originalText = match[0];

                // 3. Check if content contains any of our Latin words
                // We use word boundaries \b to ensure we don't match partial words
                const hasLatin = latinWords.some(phrase => {
                    // Escape dots for the regex (e.g., et al. -> et al\.)
                    const escapedPhrase = phrase.replace(/\./g, '\\.');
                    const regex = new RegExp(`\\b${escapedPhrase}\\b`, 'i');
                    return regex.test(content);
                });

                if (hasLatin) {
                    const suggestionText = content; // The content without \textit{}
                    const pos = getPositionFromIndex(texFile, match.index, originalText.length);

                    const position = {
                        startRow: pos.startRow,
                        startCol: pos.startCol,
                        endRow: pos.endRow,
                        endCol: pos.endCol,
                    };

                    // 4. Overlap/Refresh Logic
                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                    if (overlapping.length > 0) {
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        if (isAlreadyAnchored(position, this.name, existingSuggestions, originalText)) continue;
                        if (isRejectedByLivePosition(position, this.name, originalText)) continue;
                    }

                    // 5. Create Anchor
                    createAnchor(
                        session, Range, position,
                        originalText,
                        suggestionText,
                        this.markerClass,
                        this.name,
                        this.description,
                        anchorlist
                    );
                }
            }
            return staleIds;
        }
    },







}